import { render, staticRenderFns } from "./TipoActivo.vue?vue&type=template&id=60a05fd2"
import script from "./TipoActivo.vue?vue&type=script&lang=js"
export * from "./TipoActivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports